import { createSlice } from "@reduxjs/toolkit";
import { youLoggedOut } from "./profileSlice";
import { startGame, playerPassed, diceRolled, gameEnded } from "./gameSlice";
import { setSession } from "../actions";
import { PlayerInfo, SessionInfo } from "../.././common/Info";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState: PlayerInfo[] = [];

const playersSlice = createSlice({
  name: "players",
  initialState,
  reducers: {
    setPlayers(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerReadied(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerUnreadied(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerConnected(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerDisconnected(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerJoined(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    boxMarked(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
    playerQuit(state, action: PayloadAction<PlayerInfo[]>) {
      state.length = 0;
      action.payload.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    },
  },
  extraReducers(builder) {
    builder.addCase(setSession, (state, action: PayloadAction<SessionInfo>) => {
      state.length = 0;
      action.payload.players.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    });
    builder.addCase(startGame, (state, action: PayloadAction<SessionInfo>) => {
      state.length = 0;
      action.payload.players.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    });
    builder.addCase(
      playerPassed,
      (state, action: PayloadAction<SessionInfo>) => {
        state.length = 0;
        action.payload.players.forEach((player: PlayerInfo) => {
          state.push(player);
        });
      },
    );
    builder.addCase(diceRolled, (state, action: PayloadAction<SessionInfo>) => {
      state.length = 0;
      action.payload.players.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    });
    builder.addCase(gameEnded, (state, action: PayloadAction<SessionInfo>) => {
      state.length = 0;
      action.payload.players.forEach((player: PlayerInfo) => {
        state.push(player);
      });
    });
    builder.addCase(youLoggedOut, (state) => {
      return initialState;
    });
  },
});

export const {
  setPlayers,
  playerReadied,
  playerUnreadied,
  playerConnected,
  playerDisconnected,
  playerJoined,
  playerQuit,
  boxMarked,
} = playersSlice.actions;
export const playersReducer = playersSlice.reducer;
